import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { usePower } from '../../contexts/PowerContext';
import { powerLocationById } from '../../data/power';
import { freshnessLabel } from '../../utils/power';
import { PowerStatusPill, powerIcons } from './PowerPrimitives';

/**
 * The compact Power widget for the student home screen. Three rows, because home
 * answers "what do I need to do today" — the full picture lives at /power.
 */
export function PowerWidget() {
  const {
    homeLocationId,
    campusLocationId,
    next,
    getLocationStatus
  } = usePower();
  const Zap = powerIcons.power;
  const rows = [{
    label: 'Your accommodation',
    id: homeLocationId
  }, {
    label: 'Campus',
    id: campusLocationId
  }, {
    label: next?.locationId ? powerLocationById(next.locationId)?.name ?? 'Next class' : 'Next class',
    id: next?.locationId ?? null
  }];
  const newest = rows.map(row => row.id ? getLocationStatus(row.id).lastConfirmedAt : null).filter((value): value is string => Boolean(value)).sort().at(-1);
  return <section aria-labelledby="power-widget" className="flex flex-col rounded-2xl border border-line bg-surface p-5 shadow-panel" data-id="element-4332" data-mp="4rdk4dg1sl4w">
      <div className="flex items-center gap-2" data-id="element-4333" data-mp="ijlgw57c0c3l">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-50 text-brand-700" data-id="element-4334" data-mp="dpzcf0bbneiv">
          <Zap className="h-4 w-4" aria-hidden data-id="element-4335" data-mp="selqyzt4k291" />
        </span>
        <h2 id="power-widget" className="text-h4 font-semibold text-ink" data-id="element-4336" data-mp="nh3pfuhfspb2">
          Power status
        </h2>
      </div>
      <ul className="mt-3.5 space-y-2.5" data-id="element-4337" data-mp="11gv1hpoe7vmf">
        {rows.map(row => {
        const status = row.id ? getLocationStatus(row.id) : null;
        return <li key={row.label} className="flex items-center gap-3" data-id="element-4338" data-mp="337zq0cv14g2j">
              <span className="min-w-0 flex-1 truncate text-body-sm text-ink" data-id="element-4339" data-mp="33884282w1rfb">{row.label}</span>
              {status ? <PowerStatusPill state={status.state} size="xs" data-id="element-4340" data-mp="2yb9bvv2sbujr" /> : <span className="shrink-0 text-caption text-ink-subtle" data-id="element-4341" data-mp="127uugrumr741">Not mapped</span>}
            </li>;
      })}
      </ul>
      <p className="cz-num mt-3 text-caption text-ink-subtle" data-id="element-4342" data-mp="1c3od8syxzwu9">
        {newest ? `Updated ${freshnessLabel(newest)}` : 'No recent reports'}
      </p>
      <Link to="/power" className="mt-3 inline-flex min-h-touch items-center gap-1.5 text-body-sm font-medium text-brand-700 hover:underline" data-id="element-4343" data-mp="1g3f1oq0zy0vm">
        Before you go
        <ArrowRightIcon className="h-4 w-4" aria-hidden data-id="element-4344" data-mp="1q1uuqyjl3k7r" />
      </Link>
    </section>;
}